import axios from "axios";

/**
 * WHY: One axios instance = consistent baseURL + headers + error handling.
 */
const resolveBaseUrl = () => {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    // Always connect to local backend when running on localhost or 127.0.0.1
    if (host === "localhost" || host === "127.0.0.1") {
      return "http://localhost:8091";
    }
    // On production VPS domain, use origin (Nginx reverse proxies /api directly to port 8091)
    if (host.includes("lumigo.smarthrms.cloud") || (!host.includes("localhost") && !host.includes("127.0.0.1"))) {
      return window.location.origin;
    }
  }
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  return "http://localhost:8091";
};

export const api = axios.create({
  baseURL: resolveBaseUrl(),
  timeout: 25000,
  headers: { "Content-Type": "application/json" },
});

// Attach token automatically from localStorage
api.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem("lumigo_auth") || localStorage.getItem("watchstore_auth");
    const parsed = raw ? JSON.parse(raw) : null;
    const token = parsed?.token;

    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch {
    // ignore
  }
  return config;
});

// Intercept 401 Unauthorized / Token Expired (30min limit)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const data = error.response.data;
      const isExpired = data?.code === "TOKEN_EXPIRED" || data?.expired || data?.message?.toLowerCase().includes("expired");
      
      if (typeof window !== "undefined") {
        const raw = localStorage.getItem("lumigo_auth") || localStorage.getItem("watchstore_auth");
        const parsed = raw ? JSON.parse(raw) : null;
        const isAdmin = parsed?.user?.role === "admin" || parsed?.user?.role === "superadmin" || window.location.pathname.startsWith("/admin");
        
        if (isExpired && (window.location.pathname.startsWith("/admin") || window.location.pathname.startsWith("/customer"))) {
          localStorage.removeItem("lumigo_auth");
          localStorage.removeItem("watchstore_auth");
          const target = isAdmin ? "/admin-login?sessionExpired=true" : "/login?sessionExpired=true";
          if (!window.location.pathname.includes("login")) {
            window.location.href = target;
          }
        }
      }
    }
    return Promise.reject(error);
  }
);
